// FEATURE 3: Readiness score with server-side caching
import { create } from 'zustand';
import { api } from '../api/client';

export interface ReadinessItem {
  id: string;
  label: string;
  done: boolean;
  points: number;
  link: string;
}

interface ReadinessState {
  score: number;
  checklist: ReadinessItem[];
  startupId: string | null;
  isOpen: boolean;
  setData: (checklist: ReadinessItem[], startupId: string) => void;
  openPanel: () => void;
  closePanel: () => void;
}

let saveTimer: ReturnType<typeof setTimeout> | null = null;

export const useReadinessStore = create<ReadinessState>((set, get) => ({
  score: 0,
  checklist: [],
  startupId: null,
  isOpen: false,
  setData: (checklist, startupId) => {
    const score = checklist.reduce((sum, item) => sum + (item.done ? item.points : 0), 0);
    set({ score, checklist, startupId });
    // Debounce server-side cache update
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(() => {
      api.put(`/startups/${startupId}`, { readinessScore: score }).catch(() => {});
    }, 2000);
  },
  openPanel: () => set({ isOpen: true }),
  closePanel: () => set({ isOpen: false }),
}));
